import React, { useState, useEffect } from 'react'
import CityPlan from './CityPlan'
import CityPlanFilterWrapper from './CityPlanFilterWrapper'
import { getLocationsData } from './util'

export default props => {
  const { campaignResults, ...otherProps } = props
  const [locationData, setLocationData] = useState(null)

  const getData = async () => {
    try {
      setLocationData(null)
      const locationData = await getLocationsData(campaignResults, otherProps)
      setLocationData(locationData)
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    getData()
  }, [otherProps.cityPlanId])

  return (
    locationData != null && (
      <CityPlanFilterWrapper
        campaignResults={props.campaignResults}
        location={props.location}
        history={props.history}
        locationData={locationData}
      >
        <CityPlan {...props} locationData={locationData} />
      </CityPlanFilterWrapper>
    )
  )
}



// WEBPACK FOOTER //
// ./src/Containers/StatsCityPlan/index.js